import React, { useEffect, useState } from 'react';

function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    fetch('https:/fro.ro/api/events/index.php?club_id=1', {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })

      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setEvents(data.data);
        } else {
          setError('Eroare la încărcarea evenimentelor');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Eroare la conexiune');
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Se încarcă evenimentele...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div style={{ maxWidth: 600, margin: 'auto', padding: 20 }}>
      <h2>Evenimente club</h2>
      {events.length === 0 && <p>Nu există evenimente.</p>}
      <ul>
        {events.map(ev => (
          <li key={ev.id} style={{ marginBottom: 15 }}>
            <strong>{ev.name}</strong><br />
            Perioadă: {ev.start_date} - {ev.end_date}<br />
            Locație: {ev.location}<br />
            <a href={ev.live_results_url} target="_blank" rel="noreferrer">Rezultate live</a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Events;
